<!-- 新房--详情--楼盘相册详情 -->
<template>
  <div class="bgBlue">
    <!-- 导航头部组件 -->
    <HeaderNav chooseNav="1"></HeaderNav>
    <!-- 广告 -->
    <div style="height: 100px"></div>
    <div class="add">
       <div class="addBg"><img :src="advertInfo.image" class="img" @click="linkOut(advertInfo.url)" /></div>
    </div>

    <!-- 右侧导航 -->
    <RightNav></RightNav>

    <!-- 脚步导航组件 -->
    <FooterNav></FooterNav>
  </div>
</template>

<script>
import HeaderNav from '../../components/HeaderNav';
import FooterNav from '../../components/FooterNav';
import Banners from '../../components/Banners.vue';
import RightNav from '../../components/RightNav.vue';
import { apiGetDetail, apiChangeOther, apiAddNotes } from '../../api/job.js';
export default {
  name: 'Index',
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    Banners: Banners,
    RightNav: RightNav
  },
  data() {
    return {
      advertInfo: { image: '../../static/pC/ad.png' },
      login: false, //是否登录
      userInfo: [] ,//是否登录--用户信息
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.judgeLogin();
    this.getIndex();
  },
  methods: {
    //跳转到外部链接
    linkOut(url){
      if(url.includes('https://') || url.includes('http://') ){
      	window.location.href = url
      }else{
      	window.location.href = `https://${url}`
      }
    },
    
    
    //判断是否登录
    judgeLogin() {
      if (sessionStorage.getItem('login') != null && sessionStorage.getItem('login') != '') {
        this.login = sessionStorage.getItem('login');
        if (sessionStorage.getItem('userInfo') != null && sessionStorage.getItem('userInfo') != '') {
          var userInfo = sessionStorage.getItem('userInfo');
          this.userInfo = JSON.parse(userInfo);
        }
      }
    }
  }
};
</script>
<style scoped>
/* 广告 */
.add {
  padding: 0;
  max-width: 1200px;
  margin: 0 auto;
}
.addBg {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
.addBg .img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/Job/BuildImgDetail.vue